import { useEffect, useState } from 'react'

import { FloppyDiskIcon } from '@hugeicons/react'
import { useWatch } from 'react-hook-form'


import { useResourceRecordContext } from '@/shared/hooks'
import { Button } from '@/shared/ui'
import { FormControl, FormGroup, InputGroup } from '@/shared/ui/Form'


export const DigitalProductMyProfileFields = ({ currentName }) => {
  const { record: user, isSubmitting } = useResourceRecordContext()
  const watchName = useWatch({ name: 'name', defaultValue: currentName })

  const hasNameChanged = watchName !== currentName && watchName.trim() !== ''

  return (
    <FormGroup
      label="Seu nome completo"
      wrapperClassName="w-full"
      required
      vertical
    >
      <InputGroup>
        <FormControl name="name" solid />
        <Button
          type="submit"
          variant="ghost"
          icon
          disabled={isSubmitting || !hasNameChanged}
          leadingIcon={<FloppyDiskIcon variant="duotone" size={18} />}
          className="shrink-0 rounded-none border-0"
          aria-label="Salvar nome"
        />
      </InputGroup>
    </FormGroup>
  )
}
